import Api from "./Api.js";

export default {
  all() {
    return Api.get("sectors/");
  },
};
